import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { BusinessUnitsData } from 'client/bundles/types';
import Hint from 'client/components/hint';

import CountryDescriptor from '../country-descriptor';
import './index.css';

const b = cn('country-badge');
const HINT_WIDTH = 380;

interface Props {
    badgeStyle: string;
    country: string;
    type: string;
    description: string;
    coordinates: [number, number];
    businessUnitsLabel: string;
    businessUnits: BusinessUnitsData[];
}

interface State {
    visibleHint: boolean;
}

class CountryBadge extends Component<Props, State> {
    private badgeRef = React.createRef<HTMLDivElement>();

    constructor(props: Props) {
        super(props);

        this.state = {
            visibleHint: false
        };
    }

    componentDidMount() {
        // Прокидываем актуальный badgeRef в Hint после отрисовки
        this.forceUpdate();
    }

    componentDidUpdate() {
        const { visibleHint } = this.state;

        if (visibleHint) {
            setTimeout(() => {
                document.addEventListener('click', this.handleClickOutside);
            }, 0);
        } else {
            document.removeEventListener('click', this.handleClickOutside);
        }
    }

    render() {
        const { badgeStyle, country, description, coordinates, type, businessUnits, businessUnitsLabel } = this.props;
        const { visibleHint } = this.state;
        const [x, y] = coordinates;

        return (
            <div
                ref={this.badgeRef}
                className={b({ type, active: visibleHint })}
                style={{
                    backgroundImage: `url(${badgeStyle})`,
                    left: `${x}%`,
                    top: `${y}%`
                }}
                onClick={this.handleClick}
                >
                <Hint
                    mixClassName={b('hint')}
                    parentNode={this.badgeRef.current}
                    width={HINT_WIDTH}
                    >
                    <CountryDescriptor
                        country={country}
                        description={description}
                        businessUnitsLabel={businessUnitsLabel}
                        businessUnits={businessUnits}
                        />
                </Hint>
            </div>
        );
    }

    private handleClickOutside = () => {
        this.setState({ visibleHint: false });
    }

    private handleClick = () => {
        const { visibleHint } = this.state;

        if (!visibleHint) {
            this.setState({ visibleHint: true });
        }
    }
}

export default CountryBadge;
